<div class="modal-header border-bottom-0">
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <app-close-icon></app-close-icon>
  </button>
</div>
<div class="modal-body">
  <div class="image">
    <img src="/assets/vectors/task_alt.svg" alt="">
  </div>
  <h4 class="modal-title body-bold-16 slate-600">
    {{title}}
  </h4>
  <p class="text" *ngFor="let text of texts">
    {{text}}
  </p>
</div>
<div class="modal-footer border-top-0">
  <div class="actions m-0">
    <button type="button" class="btn btn-primary mx-16" (click)="activeModal.close()">
      {{buttonText}}
    </button>
  </div>
</div>